// extracted by mini-css-extract-plugin
export default {"card":"j2-z","carouselContainer":"k2-z","carouselContent":"l2-z"};